var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import moment from 'moment-timezone';
import { AuthApiMutation } from '../../../../infra/api/base-endpoints';
import { queryKeys as walkInListQueryKeys } from './query-keys';
import { queryKeys as sessionQueryKeys } from '../../../../infra/session/query-keys';
import { createSession } from '../../../../infra/session/utils';
import { getSessionShop } from '../../../../infra/session';
import config from '../../../../../config';
var NotifyWalkInSlotMutation = /** @class */ (function (_super) {
    __extends(NotifyWalkInSlotMutation, _super);
    function NotifyWalkInSlotMutation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotifyWalkInSlotMutation.prototype.request = function (payload) {
        var options = this.buildOptions();
        console.log('[DEBUG] notifyWalkInSlotMutation options', options);
        return this.http.post("/v1/walk-in-list/slot/".concat(payload.walkInSlotId, "/notify"), payload, options);
    };
    NotifyWalkInSlotMutation.prototype.afterMutationSuccess = function (queryClient) {
        var user = queryClient.getQueryData(sessionQueryKeys.currentSession());
        var sessionShop = getSessionShop(createSession(user));
        var today = moment()
            .tz((sessionShop === null || sessionShop === void 0 ? void 0 : sessionShop.timezone) || config.defaultTimezone)
            .format(config.dateFormatISO);
        // Invalidate walk-in list queries
        queryClient.invalidateQueries({
            queryKey: walkInListQueryKeys.shopActive(sessionShop === null || sessionShop === void 0 ? void 0 : sessionShop.id),
        });
        queryClient.invalidateQueries({
            queryKey: walkInListQueryKeys.shopHistory(sessionShop === null || sessionShop === void 0 ? void 0 : sessionShop.id, today),
        });
        // Invalidate waiting list queries since unified view includes both
        queryClient.invalidateQueries({
            queryKey: ['waiting-list-current', sessionShop === null || sessionShop === void 0 ? void 0 : sessionShop.id],
        });
        queryClient.invalidateQueries({
            queryKey: ['waiting-list-history', sessionShop === null || sessionShop === void 0 ? void 0 : sessionShop.id, today],
        });
    };
    return NotifyWalkInSlotMutation;
}(AuthApiMutation));
export { NotifyWalkInSlotMutation };
